import UseInstall from "../hooks/UseInstall";
import { isMobile } from "react-device-detect";
import "../styles/layouts/infopage.scss";

const newsletterURL = process.env.REACT_APP_NEWSLETTER_URL;
const shareObj = {
  title: 'Campos Magnéticos',
  url: 'https://camposmagneticos.netlify.app/'
};
const canShare = navigator && navigator.canShare && navigator.canShare(shareObj);


export default function InfoPage({ hidden }) {
  const [{ mayInstall }, { prompt }] = UseInstall();

  return (
    <div className="infoPage">
      <div className={`info-page-inner ${hidden ? "hidden" : ""}`}>
        <div className="info-text-content main-text">
          Campos Magnéticos é um arquivo-vivo que procura documentar, mapear e divulgar a rede informal de espaços artístico-culturais autogeridos no Porto, a partir dos anos 80. O projeto realiza-se entre outubro 2023 e junho 2024, na cidade, contando com o desenvolvimento de uma plataforma digital de livre acesso, que viabiliza a partilha deste mapeamento com a comunidade; um programa de Expansões de Campo – caminhadas que aproximam espaços em funcionamento e projetos míticos, já encerrados, convocando a presença dos seus agentes; uma exposição no Espaço Mira e o lançamento de uma publicação final.        </div>
        <div className="info-staff info-text-content">
          Organização e investigação: Filipa Valente<br></br>
          Desenvolvimento web: Rui Santos<br></br>
          Design editorial: Joana Oliveira<br></br>
          Fotografia e vídeo: Ana Carvalho dos Santos<br></br>
        </div>
        <div className="info-page-footer-container">
          <div className="info-page-footer">
            <div>
              <div onClick={() => {
                window.open('mailto:camposmagneeticos@gmail.com')
              }}>
                E-mail
              </div>
              <div onClick={() => {
                window.open('https://www.instagram.com/campos.magneeticos', '_blank')
              }}>
                Instagram
              </div>
              {true &&
                <div onClick={prompt}>
                  Instalar App
                </div>
              }
              {true &&
                < div onClick={async () => {
                  try {
                    await navigator.share(shareObj)
                  } catch (e) {

                  }
                }}>
                  Partilhar
                </div>
              }
            </div>
            <div className="logo-container">
              <img src="/logos/logo_criatorio.png"></img>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}
